import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RookeryBoldFont, RookeryRegularFont } from 'v3/styles/common';

export const TitleLargeStyled = styled(Typography)<TypographyProps>(({ theme }) => ({
  font: `400 1.375rem ${RookeryRegularFont}`,
}));

export const TitleLargeBoldStyled = styled(Typography)<TypographyProps>(({ theme }) => ({
  font: `700 1.375rem ${RookeryBoldFont}`,
}));
